import React from 'react';
import { TouchableOpacity, StyleSheet } from 'react-native';
import { SVG_COMPONENTS } from '@/assets/admin';
import { useThemeColors } from '@/hooks/shared/useThemeColors';

const CloseIcon = SVG_COMPONENTS.CANCEL_X;

interface CloseButtonProps {
  onPress: () => void;
  color?: string;
  size?: number;
  hitSlop?: { top: number; bottom: number; left: number; right: number };
}

/**
 * Shared modal close control: a 32px glass pill around the X, exposed to
 * assistive tech as a "Close" button. The 8px hitSlop lifts the touch target
 * past the 44pt guideline.
 */
export const CloseButton: React.FC<CloseButtonProps> = ({
  onPress,
  color,
  size = 14,
  hitSlop = { top: 8, bottom: 8, left: 8, right: 8 },
}) => {
  const { colors } = useThemeColors();
  return (
    <TouchableOpacity
      style={[
        styles.button,
        { backgroundColor: colors.glass.buttonBg, borderColor: colors.glass.buttonBorder },
      ]}
      onPress={onPress}
      activeOpacity={0.8}
      hitSlop={hitSlop}
      accessibilityRole="button"
      accessibilityLabel="Close"
    >
      <CloseIcon width={size} height={size} color={color ?? colors.text.muted} />
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  button: {
    width: 32,
    height: 32,
    borderRadius: 16,
    borderWidth: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
});
